<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Notify Pros'"
      [canGoBack]="!fromGettingStarted" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'We recommend sending your pros a short message notifying them of your changes. Use this to help craft a message:'" />
      </tidy-row>

      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="card-header">
            <tidy-text
              [header]="'Craft Your Message'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Message to send (you can edit this):'" />
          </tidy-row>
          <div class="message-editor">
            <ion-textarea
              formControlName="messageText"
              placeholder="Your message will appear here..."
              [autoGrow]="true"
              [rows]="10"
              class="message-textarea" />
          </div>
        </form>
      </tidy-card>

      <tidy-card>
        <tidy-row class="card-header">
          <tidy-text
            [header]="'Select How to Send'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-radio-button
            [items]="howToSendItems"
            [form]="form.controls.howToSend"
            formControlName="howToSend" />
        </form>
        @if (form.value.howToSend == 'copy') {
          <tidy-row class="extra-top-padding">
            <tidy-text
              [body]="'Copy Message'"
              class="link"
              (action)="copyMessage()" />
            @if (messageCopied) {
              <tidy-text
                style="margin-left:5px"
                [helper]="'Copied'" />
            }
          </tidy-row>
        }
      </tidy-card>

      <tidy-card>
        <tidy-row class="card-header">
          <tidy-text
            [header]="'Select Pros to Send to'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-radio-button
            [items]="proScopeItems"
            [form]="form.controls.proScope"
            formControlName="proScope" />
        </form>
        @if (form.value.proScope === 'select') {
          <div style="margin-top: 5px;"></div>
          @for (pro of allProItems; track pro.value) {
            <tidy-checkbox
              [initValue]="true"
              [items]="[{viewValue: pro.viewValue, value: true}]"
              (checkedChange)="updateSelectedPros(pro)" />
          }
        }
      </tidy-card>

      @if (form.value.howToSend == 'sms') {
        <tidy-row class="align-right" style="margin-bottom: 10px;">
          @if (!fromGettingStarted) {
            <tidy-button
              [text]="'Back'"
              [action]="goBack"
              class="secondary" />
            <tidy-button
              [text]="'Skip'"
              [action]="skipStep"
              class="secondary" />
          }
          <tidy-button
            [text]="'Send SMS to Pros'"
            [action]="sendSMSToPros"
            class="primary" />
        </tidy-row>
      }
      @if (form.value.howToSend == 'copy') {
        <tidy-row class="align-right" style="margin-bottom: 10px;">
          @if (!fromGettingStarted) {
            <tidy-button
              [text]="'Back'"
              [action]="goBack"
              class="secondary" />
            <tidy-button
              [text]="'Skip'"
              [action]="skipStep"
              class="secondary" />
          }
          <tidy-button
            [text]="'Complete Step'"
            [action]="completeStep"
            class="primary" />
        </tidy-row>
      }

      @if (sendingInProgress) {
        <tidy-card>
          <tidy-row class="card-header">
            <tidy-text
              [header]="'Sending messages to pros...'" />
          </tidy-row>
          <div class="pro-list">
            @for (item of prosSendStatus; track item.pro.value) {
              <div class="pro-item">
                <span class="pro-name">{{ item.pro.viewValue || 'Unknown Pro' }}</span>
                <span class="pro-status" [ngClass]="'status-' + item.status">
                  @switch (item.status) {
                    @case ('pending') { ⏳ Waiting }
                    @case ('sending') { 📤 Sending... }
                    @case ('success') { ✅ Sent }
                    @case ('error') { ❌ Failed{{ item.error ? ': ' + item.error : '' }} }
                  }
                </span>
              </div>
            }
          </div>
        </tidy-card>
      }
    }

    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
